<template>
	<transition name="slide-fade">
		<div class="modal-container">
			<div class="modal" @click.stop>
				<div class="modal-header">
					<div class="modal-title">
						<span v-if="showUserList">Shared By</span>
						<span v-else>Story</span>&nbsp;
						<span v-if="!showUserList" class="story-counter">{{story.story.noInStack}}</span>
					</div>
					<div class="close" title="close">
						<ion-icon name="ios-close" @click="closeModal"></ion-icon>
					</div>
				</div>
				<div class="modal-body">
					<div class="story-image">
						<source-tag :story="story.story" :format="'tag'"></source-tag>
						<img v-if="story.story.urlToImage" :src="story.story.urlToImage" alt="Story image" />
						<ion-icon v-else name="images"></ion-icon>
						<div class="story-title">
							<p>{{story.story.title}}</p>
						</div>
					</div>
					<div class="story-count" v-if="showUserList">
						<span class="shared-length">Shared by {{story.users.length}} readers</span>
					</div>
					<div class="users-list-container" v-if="showUserList">
						<div class="loading-container" v-if="loading">
							<loading></loading>
						</div>
						<users-list v-else-if="!loading && story.users" :users="story.users"></users-list>
					</div>
					<div v-else>
						<hr />
						<story-body :story="story.story"></story-body>
						<br />
						<story-footer :storyUrl="story.story.url"></story-footer>
					</div>
				</div>
				<div v-if="!showUserList && story.nextStory !== undefined" class="modal-footer">
					<a :class="[noPrevStory ? noStory : '']" @click="prevStory">
						<ion-icon name="ios-return-left" :class="[noPrevStory ? noStory : 'hydrated']"></ion-icon>Prev Story
					</a>
					<a :class="[noNextStory ? noStory : '']" @click="nextStory">
						Next Story
						<ion-icon name="ios-return-right" :class="[noNextStory ? noStory : 'hydrated']"></ion-icon>
					</a>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import UsersList from "../users/userView/UsersList.vue";
import StoryBody from "../story/StoryBody.vue";
import StoryFooter from "../story/StoryFooter.vue";
import SourceTag from "../sources/SourceTag.vue";
import Loading from "../errors/PageLoading.vue";

export default {
	data() {
		return {
			loading: true,
			noStory: "no-story hydrated"
		};
	},
	mounted() {
		console.log(this.story.hasOwnProperty("prevStory"));
	},
	computed: {
		story() {
			return this.$store.getters.getStoryModal;
		},
		showUserList() {
			return this.story.users !== null;
		},
		noPrevStory() {
			return this.story.prevStory === null;
		},
		noNextStory() {
			return this.story.nextStory === null;
		}
	},
	components: {
		UsersList,
		StoryBody,
		StoryFooter,
		SourceTag,
		Loading
	},
	mounted() {
		const modalContainer = document.querySelector(".modal-container");
		modalContainer.addEventListener("click", this.closeModal);

		setTimeout(() => {
			this.loading = false;
		}, 500);
	},
	methods: {
		prevStory() {
			let payload = {
				show: true,
				users: null,
				story: this.story.prevStory,
				prevStory: this.story.prevStory.prevStory,
				nextStory: this.story.prevStory.nextStory
			};

			this.$store.commit("updateRecentReadsActivity", this.story);
			this.$store.commit("updateStoryModal", payload);
		},
		nextStory() {
			let payload = {
				show: true,
				users: null,
				story: this.story.nextStory,
				prevStory: this.story.nextStory.prevStory,
				nextStory: this.story.nextStory.nextStory
			};

			this.$store.commit("updateRecentReadsActivity", this.story);
			this.$store.commit("updateStoryModal", payload);
		},
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			let payload = {
				show: false,
				users: null,
				story: null,
				prevStory: null,
				nextStory: null
			};

			this.$store.commit("updateStoryModal", payload);
		}
	}
};
</script>

<style lang="css" src="../../styles/modalStyles.css" scoped></style>
<!--<style lang="scss" scoped>
    @import "../../styles/modalStyles.scss";
</style>-->
<style lang="css" src="../../styles/cardStyles.css" scoped></style>
<style scoped>
.story-image {
	position: relative;
	height: 200px;
}

.story-title {
	position: absolute;
	bottom: 0px;
	background-color: #000000ad;
	overflow: hidden;
	padding: 10px 15px;
	width: 100%;
	border-bottom-left-radius: 20px;
	border-bottom-right-radius: 20px;
}

.story-counter {
	background-color: #171717 !important;
	border-radius: 0px;
	padding-left: 2px !important;
	font-size: 10px !important;
	color: #b7b7b7;
	font-weight: 100 !important;
}

.story-count {
	text-align: center;
	color: #b7b7b7;
	font-size: 11px;
	margin-top: 10px;
}

img {
	height: 200px;
	width: 100%;
	object-fit: cover;
	border-radius: 20px;
}

p {
	font-weight: bold;
	font-size: 17px;
}

.loading-container {
	height: 300px;
	position: relative;
}

.users-list-container {
	max-height: 300px;
	overflow: auto;
	padding-top: 10px;
}

hr {
	background-color: #000;
	height: 1px;
	margin: 20px 0px 10px;
}

.modal-footer {
	margin-top: 10px;
	display: flex;
	justify-content: space-between;
}

.modal-footer ion-icon {
	font-size: 17px;
	vertical-align: middle;
	color: #51c715;
}

.modal-footer a {
	color: #51c715;
	text-decoration: underline;
}

.no-story {
	pointer-events: none;
	color: #b7b7b7 !important;
	cursor: not-allowed;
}

.shared-length {
	text-align: center;
	font-size: 10px;
	color: #51c715;
	margin: 15px auto 10px;
	padding: 3px 10px;
	border: 1px solid #51c715;
	border-radius: 20px;
	width: fit-content;
}

ion-icon[name="images"] {
	color: #b7b7b7;
	font-size: 34px;
	border: 2px solid #b7b7b7;
	border-radius: 50%;
	padding: 10px;
	position: absolute;
	left: 50%;
	top: 30%;
	transform: translate(-50%, -50%);
	margin: 0;
}

@media only screen and (max-width: 540px) {
	p {
		font-size: 13px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/modals/StoryModal.vue